import { FilterOption, PlpFilterItemProps } from '../PlpFilters.type';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { IconEmissions } from 'src/general/Icons/IconEmissions';
import { FilterSelectItem } from '../components/Fields/FilterSelectItem';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

export const FilterCO2 = ({
  options,
  value,
  index,
  showNotificationBadge,
  ...props
}: PlpFilterItemProps<FilterOption>) => {
  const id = 'co2Emissions';
  const header = (
    <FilterName icon={<IconEmissions />} label="CO2 emissions" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <FilterSelectItem
      name="co2Emissions"
      id="co2Emissions"
      data-testid="co2Emissions"
      options={options}
      size="small"
      defaultValue={value}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
